<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
              <span class="px-3">{{ $t('Add New Salesman') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex pa-2 xs11 :class="{ xs12: !hasPermissions(['users_store']) }">
              <v-autocomplete
                id="salesman-focus-me"
                v-model="form.user_id_fk"
                :items="staffsList"
                :label="`${$t('Staff')} *`"
                box
                hide-details
                :error="errors.has('Staff')"
                background-color="white"
                v-validate="'required'"
                data-vv-name="Staff"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-staff')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new staff') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs8 pa-2 :class="{ xs12: form.commissionList === 'No Commission' }">
              <v-autocomplete
                v-model="form.commissionList"
                :items="commissionList"
                :label="`${$t('Commission Type')} *`"
                box
                hide-details
                browser-autocomplete
                background-color="white"
                data-vv-name="commission_type"
                :menu-props="{ transition: 'slide-y-transition' }"
                :error="errors.has('commission_type')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs4 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.percentage"
                :label="$t('Percentage')"
                name="sale_man_commission_percentage"
                box
                hide-details
                suffix="%"
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage')"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.quota1"
                :label="$t('Quota 1')"
                name="sale_man_quota_1"
                box
                v-validate="'decimal'"
                :error="errors.has('sale_man_quota_1')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.percentage1"
                :label="$t('Percentage 1')"
                name="sale_man_commission_percentage_1"
                box
                hide-details
                suffix="%"
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage_1')"
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.quota2"
                :label="$t('Quota 2')"
                name="sale_man_quota_2"
                box
                v-validate="'decimal'"
                :error="errors.has('sale_man_quota_2')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.percentage2"
                :label="$t('Percentage 2')"
                name="sale_man_commission_percentage_2"
                box
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage_2')"
                suffix="%"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.quota3"
                :label="$t('Quota 3')"
                name="sale_man_quota_3"
                box
                v-validate="'decimal'"
                :error="errors.has('sale_man_quota_3')"
                hide-details
                background-color="white"
              />
            </v-flex>

            <v-flex xs6 class="pa-2">
              <v-text-field
                v-if="form.commissionList && form.commissionList !== 'No Commission'"
                v-model="form.percentage3"
                :label="$t('Percentage 3')"
                name="sale_man_commission_percentage_3"
                box
                v-validate="'decimal|between:0,100'"
                :error="errors.has('sale_man_commission_percentage_3')"
                suffix="%"
                hide-details
                background-color="white"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {},
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      staffsList: 'staff/getFullStaffsList',
      commissionList: 'salesmen/getCommissionList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addSalesman: 'salesmen/addSalesman'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.commissionList = 'No Commission'
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('salesman-focus-me').focus()
      })
    },

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true

          let formData = new FormData(event.target)
          formData.append('commission_type', this.form.commissionList || '')
          formData.append('user_id_fk', this.form.user_id_fk)

          this.addSalesman(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
